import React from 'react';
import { Link } from 'react-router-dom';
import SmartdoxxLogo from './SmartdoxxLogo';
import UserAvatarDropdown from './UserAvatarDropdown';
import { useAuth } from '../hooks/useAuth';

interface AppHeaderProps {
  userName?: string;
  showDashboardLink?: boolean;
}

export default function AppHeader({ userName = 'Admin Account1', showDashboardLink = false }: AppHeaderProps) {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <header className="bg-card shadow-sm border-b border-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8 flex justify-between items-center">
        <Link to="/dashboard">
          <SmartdoxxLogo size="md" showText={true} />
        </Link>
        {user && (
          <div className="flex items-center gap-3">
            {showDashboardLink && (
              <Link
                to="/dashboard"
                className="px-3 py-2 text-sm font-medium text-foreground bg-muted rounded-lg hover:bg-muted/80 transition"
              >
                Back to dashboard
              </Link>
            )}
            <UserAvatarDropdown
              email={user.email || ''}
              name={userName}
              onSignOut={handleSignOut}
            />
          </div>
        )}
      </div>
    </header>
  );
}
